import * as tslib_1 from "tslib";
import selectReadReceiptOption from '../actions/selectReadReceiptOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var ReadReceiptsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReadReceiptsFull, _super);
    function ReadReceiptsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectReadReceiptOption(option.key);
        };
        return _this;
    }
    ReadReceiptsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var selectedKey = getFallbackValueIfNull(optionStore.readReceiptResponse, userOptions.ReadReceipt);
        var choices = [
            {
                key: 'DoNotAutomaticallySend',
                text: strings.options_mail_ReadReceiptPrompt,
            },
            {
                key: 'AlwaysSend',
                text: strings.options_mail_ReadReceiptAlways,
            },
            {
                key: 'NeverSend',
                text: strings.options_mail_ReadReceiptNever,
            },
        ];
        return (React.createElement(ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange, label: strings.options_mail_ReadReceiptTitle }));
    };
    ReadReceiptsFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], ReadReceiptsFull);
    return ReadReceiptsFull;
}(React.Component));
export default ReadReceiptsFull;
//# sourceMappingURL=ReadReceiptsFull.js.map